export interface IBrandconfigMerchant {
  unsupportedCardType: string;
  minTrsAmount: string;
  maxTrsAmount: string;
  onlineCreIndi: boolean;
  cardValidityCheck: boolean;
  maxLifeOfCard: string;
  minLengthOfCardNum: string;
  maxLengthOfCardNum: string;
}
